import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const StructurePage = lazy(() => import('../pages/structure/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const ImprintPage = lazy(() => import('../pages/imprint/page'));
const PrivacyPage = lazy(() => import('../pages/privacy/page'));
const CookieSettingsPage = lazy(() => import('../pages/cookie-settings/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />
  },
  {
    path: '/about',
    element: <AboutPage />
  },
  {
    path: '/structure',
    element: <StructurePage />
  },
  {
    path: '/contact',
    element: <ContactPage />
  },
  {
    path: '/imprint',
    element: <ImprintPage />
  },
  {
    path: '/privacy-policy',
    element: <PrivacyPage />
  },
  {
    path: '/cookie-settings',
    element: <CookieSettingsPage />
  },
  {
    path: '*',
    element: <NotFoundPage />
  }
];

export default routes;